export const LOGIN_TOKEN = "TRATKN";
export const FAQ_PHONE_NUM = "02-6925-5292";
export const REQUEST_MAX_SIZE = 1000000;
export const KAKAO_JAVASCRIPT_KEY = "b3c874ce4d7268da1520e824f01b6cd7";
export const FAQ_EMAIL = "info@trustlounge.co.kr";